module.exports = __webpack_public_path__ + "img/application_icon_scheme01@2x.553a4804.png";